import gsap from 'gsap';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './cursor.css';

const Cursor = () => {
  const cursorRef = useRef(null);
  const location = useLocation();

  // Check if current page is a seller page
  const isSellerPage = location.pathname.startsWith('/seller');

  useEffect(() => {
    if (isSellerPage) return; // Don't initialize cursor on seller pages

    const cursor = cursorRef.current;
    
    const onMouseMove = (e) => {
      gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.5,
        ease: "power3.out"
      });
    };

    const onMouseEnter = () => {
      gsap.to(cursor, {
        scale: 2.5,
        duration: 0.3
      });
    };

    const onMouseLeave = () => {
      gsap.to(cursor, {
        scale: 1,
        duration: 0.3
      });
    };

    document.addEventListener('mousemove', onMouseMove);
    
    // Add hover effect for all interactive elements
    const elements = document.querySelectorAll('button, a, .qualification__button, .service__button, .tabs__button, .modal__button, .button__text');
    elements.forEach(el => {
      el.addEventListener('mouseenter', onMouseEnter);
      el.addEventListener('mouseleave', onMouseLeave);
    });

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      elements.forEach(el => {
        el.removeEventListener('mouseenter', onMouseEnter);
        el.removeEventListener('mouseleave', onMouseLeave);
      });
    };
  }, [isSellerPage]);

  // Don't render cursor on seller pages
  if (isSellerPage) return null;

  return <div ref={cursorRef} className="custom-cursor" />;
};

export default Cursor;